/* eslint-disable no-empty */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Translate, I18n } from 'react-redux-i18n';
import { Tooltip } from 'react-tippy';

import { cartUpdateItem, cartRemoveItem } from '../../app/store/actions/cart';

import NumberHelper from '../../helpers/number';
import ProductsUtil from '../../app/utils/products';
import inputSize from '../../data/inputs';
import PriceComponent from '../price/Price';
import { isXpedCharacterValid } from '../../app/utils/cart';
import validator from '../../helpers/validators';
import tagManager from '../../app/services/tagManager';

class CartTableItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this.throttleTimeout = null;
    this.throttleTimeoutMandatoryQuantity = null;
    this.throttleTime = 1000;

    this.state = {
      amount: props.item.total || 1,
      mandatoryQuantity: props.item.mandatoryQuantity || '',
      multipleQuantity: props.item.product.multipleQuantity || 1,
      xped: props.item.xped || '',
      xpedChanged: false,
    };
  }

  componentDidMount() {
    // this.updateInterval = setTimeout(this.updatePromotionCoutdown, 1000);
    const { item = {} } = this.props;
    const { product = {} } = item;
    if (product) {
      this.setState({
        multipleQuantity: product.multipleQuantity || 1,
        amount: product.quantity || 1,
        mandatoryQuantity: product.mandatoryQuantity || '',
        xped: product.xped || '',
        xpedChanged: false,
      });
    }
  }

  componentDidUpdate = (prevProps) => {
    const { item = {} } = this.props;
    const { product = {} } = item;
    const { multipleQuantity } = this.state;

    if (product) {
      if (product.multipleQuantity !== multipleQuantity) {
        this.setState({
          multipleQuantity: product.multipleQuantity,
          amount: product.quantity,
          mandatoryQuantity: product.mandatoryQuantity,
        });
      } else if (prevProps.item && prevProps.item.product && prevProps.item.product.quantity !== product.quantity) {
        this.setState({
          amount: product.quantity,
          mandatoryQuantity: product.mandatoryQuantity,
        });
      }
    }
  }

  onClickViewProduct = (e) => {
    e.stopPropagation();

    const {
      clickLocation = I18n.t('cart'),
      clickPosition = 0,
      item = {},
    } = this.props;

    const { product } = item;

    try {
      const productsToSend = [];
      const productsPromotionToSend = [];

      productsToSend.push({
        name: product.name,
        id: product.code,
        price: `${product.price ? (product.price.value || 0) : 0}`,
        brand: product.brand ? product.brand.description : '',
        category: product.category ? product.category.name : '',
        list: clickLocation,
        position: clickPosition + 1,
      });

      if (product.price && product.price.promo) {
        productsPromotionToSend.push({
          id: product.code,
          name: product.name,
          creative: clickLocation,
          position: clickPosition + 1,
        });
      }

      tagManager.ecommerceClick(productsToSend);
      tagManager.ecommercePromotionClick(productsPromotionToSend);
    } catch (err) { }
  }

  formatTotal = value => value && Number(value).toFixed(NumberHelper.countDecimals(this.state.multipleQuantity));

  textTruncate = (str, length, ending) => {
    if (length == null) {
      length = 45;
    }
    if (ending == null) {
      ending = '...';
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    }
    return str;
  };

  handleAmount = async (value) => {
    const { amount } = this.state;
    const { offHandlers } = this.props;

    if (offHandlers) return;

    const valDecCount = (amount.toString().split('.')[1] || '').length;
    const stepDecCount = (value.toString().split('.')[1] || '').length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    let valInt = parseInt(Number(amount).toFixed(decCount).replace('.', ''), 0);
    valInt = valInt <= 0 ? valInt * -1 : valInt;
    const stepInt = parseInt(Number(value).toFixed(decCount).replace('.', ''), 0);
    const qtd = ((valInt + stepInt) / (10 ** decCount));

    await this.handleSetAmount(qtd, false);
  };

  handleSetAmount = async (value, checkDecimals = true) => {
    const { allowSellSpotItensWithoutStock, item } = this.props;
    const { product = {} } = item;
    if (value === '' || value === '0' || (typeof value === 'number' && value <= 0)) {
      this.handleSetAmount(this.state.multipleQuantity || 1);
    } else if (!isNaN(value)) {
      const countedDecimals = NumberHelper.countDecimals(this.state.multipleQuantity);
      if (countedDecimals > 0 && checkDecimals) {
        value = Number(value.toString().replace(/\D+/g, ''))
          / (10 ** countedDecimals);
      }
      value = value < 0 ? 0 : value;
      if (value % 1 === 0 && countedDecimals === 0) {
        const modValue = value % product.multipleQuantity;
        if (modValue !== 0) value -= modValue;
      }
      if (value !== this.state.amount) {
        if (!this.props.isAuthenticated) {
          this.props.addItemCache(item.product.id, value - this.state.amount);
        } else {
          await this.setState({ amount: value });
          clearTimeout(this.throttleTimeout);
          this.throttleTimeout = setTimeout(async () => {
            await this.updateProductToCart(value, '', item, allowSellSpotItensWithoutStock);
          }, this.throttleTime);
        }
      }
    }

    if (validator.isSpotProductAmountInvalid(value,
      product.stock, allowSellSpotItensWithoutStock, product.isSpot, product.price.isContract)) {
      if (value !== this.state.amount) {
        if (!this.props.isAuthenticated) {
          this.props.addItemCache(item.product.id, value - this.state.amount);
        } else {
          await this.setState({ amount: value });
          this.throttleTimeout = setTimeout(async () => {
            await this.updateProductToCart(value, '', item, allowSellSpotItensWithoutStock);
          }, this.throttleTime);
        }
      }
    }

    this.onChangeMandatoryQuantity(this.state.mandatoryQuantity, false);
  };

  onChangeMandatoryQuantity = (value, update = true) => {
    let { mandatoryQuantity } = this.state;
    const oldMandatoryQuantity = mandatoryQuantity;

    if (!value) {
      mandatoryQuantity = '';
    } else if (!isNaN(`${value}`.replace(/\.|,| /g, 'x'))) {
      if (parseFloat(value) <= parseFloat(this.state.amount)) {
        mandatoryQuantity = Number(value);
      } else {
        mandatoryQuantity = parseFloat(this.state.amount);
      }
    }
    this.setState({ mandatoryQuantity });
    if (update && mandatoryQuantity !== oldMandatoryQuantity) {
      clearTimeout(this.throttleTimeoutMandatoryQuantity);
      this.throttleTimeoutMandatoryQuantity = setTimeout(async () => {
        await this.updateProductToCart();
      }, this.throttleTime);
    }
  };

  handleSetXped = async (value) => {
    if (isXpedCharacterValid(value)) {
      await this.setState({ xped: value, xpedChanged: true });
    }
  };

  onBlurXped = (item, xped) => {
    const xpedToChange = xped || '';
    if (xpedToChange !== item.xped && this.state.xpedChanged) {
      this.setState({ xpedChanged: false });
      this.updateProductToCart();
    }
  }

  updateProductToCart = async () => {
    const { amount, xped = '', mandatoryQuantity } = this.state;
    const { item = {}, allowSellSpotItensWithoutStock } = this.props;
    if (item.product) {
      if (validator.isSpotProductAmountInvalid(
        amount, item.product.stock, allowSellSpotItensWithoutStock, item.product.isSpot, item.product.price.isContract,
      )) return;
      await this.props.updateItem(item.product.id, item.product.clientCode, amount, xped, mandatoryQuantity);
    }
  };

  removeProductToCart = async () => {
    const { item = {} } = this.props;
    if (item.product) await this.props.removeItem(item.product.id, item.product.clientCode);
  };

  floatSafeModulus = (val, step) => {
    if (val && val !== '0') {
      const valDecCount = (val.toString().split('.')[1] || '').length;
      const stepDecCount = (step.toString().split('.')[1] || '').length;
      const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
      const valInt = parseInt(Number(val).toFixed(decCount).replace('.', ''), 0);
      const stepInt = parseInt(Number(step).toFixed(decCount).replace('.', ''), 0);
      return (((valInt % stepInt) + stepInt) % stepInt) / (10 ** decCount);
    }
    return 1;
  }

  renderXped = (item, xped, isCheckout = false) => {
    if ((isCheckout && item.xped) || !isCheckout) {
      return (
        <span className="small">
          <span data-toggle="tooltip" title={I18n.t('xpedTooltipText')}>
            <strong>(?)</strong>
            xPed
          </span>
          <input
            className="small-input"
            type="text"
            maxLength={inputSize.xped.max}
            value={this.state.xped}
            onChange={e => this.handleSetXped(e.target.value)}
            onBlur={() => this.onBlurXped(item, xped)}
          />
        </span>
      );
    }

    return null;
  }

  render() {
    const {
      amount = {}, xped = '', multipleQuantity, mandatoryQuantity,
    } = this.state;
    const {
      item = {}, pricePermission, stockPermission, leadTimePermission,
      taxesCart, taxName = 'ST',
      opicCodePermission, soneparCodePermission, soneparCodeOff,
      isAuthenticated, removeItem, isCheckout,
    } = this.props;

    const { product = {} } = item;

    /* const isAmountInvalid = validator.isSpotProductAmountInvalid(
      amount, item.product.stock, allowSellSpotItensWithoutStock, item.product.isSpot, item.product.price.isContract,
    ) || this.floatSafeModulus(amount, multipleQuantity) !== 0; */

    const isContract = (product.price && product.price.isContract && product.price.type === 'contract');
    const isAgreement = (product.price && product.price.isContract && product.price.type === 'agreement');
    const isDiscount = (product.price && !product.price.isContract && product.price.discount);
    const isWithoutStock = (product.isSpot && product.price && !product.price.isContract && !product.stock);
    const isContactUs = (!product.stock && product.price && product.price.contactUs);
    const isLeadTime = (leadTimePermission && (!product.stock || product.stock < amount));

    return (
      <div className="basket-product">
        <div className="coll-01">
          <span className="title-mob">{I18n.t('product')}</span>
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 13,
              top: 16,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
            }}
          >
            {isContract && (
              <Link
                className="product-seals contrato cursorPointer"
                style={{ marginBottom: 4, width: 'auto', textDecoration: 'none' }}
                to={ProductsUtil.getUrl(item.product)}
                onClick={this.onClickViewProduct}
              >
                {I18n.t('contract')}
              </Link>
            )}
            {isAgreement && (
              <Link
                className="product-seals acordo cursorPointer"
                style={{ marginBottom: 4, textDecoration: 'none' }}
                to={ProductsUtil.getUrl(item.product)}
                onClick={this.onClickViewProduct}
              >
                {I18n.t('agreement')}
              </Link>
            )}
            {isDiscount && (
              <Link
                className="product-seals desconto cursorPointer"
                style={{ marginBottom: 4, textDecoration: 'none' }}
                to={ProductsUtil.getUrl(item.product)}
                onClick={this.onClickViewProduct}
              >
                {`-${ProductsUtil.getDiscount(product.price)}`}
              </Link>
            )}
            {(isWithoutStock || isContactUs) && (
              <Link
                className="product-seals estoque cursorPointer"
                style={{ marginBottom: 4, textDecoration: 'none' }}
                to={ProductsUtil.getUrl(item.product)}
                onClick={this.onClickViewProduct}
              >
                {I18n.t('withoutStock')}
              </Link>
            )}
            {/* {isContactUs && (
              <Link
                className="product-seals consulte cursorPointer"
                style={{ marginBottom: 4, textDecoration: 'none' }}
                to={ProductsUtil.getUrl(item.product)}
                onClick={this.onClickViewProduct}
              >
                {I18n.t('consultUs')}
              </Link>
            )} */}
          </div>
          <Link
            to={ProductsUtil.getUrl(item.product)}
            className="image"
            style={{ backgroundImage: `url(${item.product.image || '/images/product-image-placeholder.png'})` }}
            title={item.product.name}
            onClick={this.onClickViewProduct}
          />
        </div>
        <div className="coll-02">
          <Link
            to={ProductsUtil.getUrl(item.product)}
            className="cursorPointer"
            style={{ textDecoration: 'none', color: 'inherit' }}
            onClick={this.onClickViewProduct}
          >
            {this.textTruncate(item.product.name)}
          </Link>
          <span className="small">
            {opicCodePermission && item.product.code && (
              <span>{`${I18n.t('code2').replace(':', '')} Nortel: ${item.product.code}`}</span>
            )}
            <br />
            {soneparCodePermission && (!soneparCodeOff && item.product.id) && (
              <span>{`${I18n.t('soneparCode')}: ${item.product.id}`}</span>
            )}
            <br />
            {item.product.clientCode && (
              <span>{`${I18n.t('clientCode2')}: ${item.product.clientCode}`}</span>
            )}
            <br />
            {item && item.product && item.product.contractId && (
              <span>{`${I18n.t('contract')}: ${item.product.contractId}`}</span>
            )}
          </span>
          {!isCheckout && (
            <span className="small">
              {(stockPermission && !!product.stock) && (
                <React.Fragment>
                  <span className="stock">{`${I18n.t('available')}: ${ProductsUtil.getStockAvailable(product.stock)}`}</span>
                  <br />
                </React.Fragment>
              )}
              {isLeadTime && (
                <span>{ProductsUtil.getStockTime(product.leadTime)}</span>
              )}
            </span>
          )}
          {this.renderXped(item, xped, isCheckout)}
        </div>
        <div className="coll-03">
          <span className="title-mob">{I18n.t('price')}</span>
          <span className="small">
            {pricePermission && (
              <React.Fragment>
                <strong><PriceComponent value={item.product.price.value + (item.product.price.icmsST || 0)} /></strong>
                {taxesCart && (
                  <React.Fragment>
                    <br />
                    <Translate value="unityPrefix" />
                    {' '}
                    <PriceComponent value={item.product.price.value} />
                    <br />
                    {`${taxName}: `}
                    <PriceComponent value={item.product.price.icmsST} force />
                    <br />
                    <i>{`ICMS: ${(item.product.price && item.product.price.icms) || 0}%`}</i>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </span>
        </div>
        {isCheckout ? (
          <div className="coll-04">
            <span className="title-mob">{I18n.t('quantity')}</span>
            {this.formatTotal(amount) || '0'}
            {product.controlLot && (
              <React.Fragment>
                <br />
                <span className="small">
                  <strong>{I18n.t('bidSize')}</strong>
                </span>
                {this.formatTotal(mandatoryQuantity) || ''}
              </React.Fragment>
            )}
          </div>
        ) : (
          <div className="coll-04" style={product.controlLot ? { marginTop: 'auto' } : {}}>
            <span className="title-mob">{I18n.t('quantity')}</span>
            <div className="basket-add">
              <button className="basket-add__less" type="button" onClick={() => this.handleAmount(-multipleQuantity)}>-</button>
              <input
                className="basket-add__qnt"
                type="text"
                maxLength={inputSize.maxDefault}
                value={this.formatTotal(amount) || '0'}
                onChange={e => this.handleSetAmount(e.target.value)}
              />
              <button className="basket-add__more" type="button" onClick={() => this.handleAmount(+multipleQuantity)}>+</button>
            </div>
            <div>
              {product.controlLot && (
                <React.Fragment>
                  <div style={{ width: '100px' }}>
                    <Tooltip
                      arrow
                      title={I18n.t('bidSizeInformative')}
                    >
                      <span className="small">
                        <strong>{I18n.t('bidSize')}</strong>
                      </span>
                    </Tooltip>
                  </div>
                  <input
                    type="text"
                    className="mandatoryQuantityInputCart"
                    maxLength={inputSize.maxDefault}
                    value={mandatoryQuantity}
                    onChange={e => this.onChangeMandatoryQuantity(e.target.value)}
                  />
                </React.Fragment>
              )}
            </div>
            <a
              className="remove cursorPointer"
              onClick={() => (isAuthenticated && removeItem(product.id, product.clientCode))}
              style={{ marginLeft: 9 }}
            >
              {I18n.t('remove')}
            </a>
          </div>
        )}
        <div className="coll-05">
          <span className="title-mob">{I18n.t('subTotal')}</span>
          <span className="small">
            {pricePermission && (
              <React.Fragment>
                <strong><PriceComponent value={((item.total * item.product.price.value) + (item.product.price.icmsST || 0))} /></strong>
                {taxesCart && (
                  <React.Fragment>
                    <br />
                    {I18n.t('unityPrefix')}
                    {' '}
                    <PriceComponent value={(item.total * item.product.price.value)} />
                    <br />
                    {`${taxName}: `}
                    <PriceComponent
                      force
                      value={item.product.price.icmsST}
                    />
                    <br />
                    <i>&nbsp;</i>
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.authenticated,
  taxesCart: state.settings && !state.settings.taxsCartOff,
  taxName: state.settings && state.settings.taxName,
  selectedContract: state.contracts.selected,
  companyName: state.settings.name,
  companyTag: state.settings.companyTag,
  allowSellSpotItensWithoutStock: state.contracts.selected
    && state.contracts.selected.clientDetails.allowSellSpotItensWithoutStock,
});

const mapDispatchToProps = dispatch => ({
  updateItem: (productId, productClientCode, total, xped = '', mandatoryQuantity) => dispatch(cartUpdateItem(productId,
    productClientCode, total, xped, undefined, mandatoryQuantity)),
  removeItem: (productId, productClientCode) => dispatch(cartRemoveItem(productId, productClientCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartTableItem);
